import { apiAxiosInstance, githubOAuthAxiosInstance } from '../axiosInstance'
import { githubRoutes } from '../route'

const link = (token) => {
  return apiAxiosInstance.post(githubRoutes.link(), token)
}

const token = (code) => {
  return githubOAuthAxiosInstance.post(githubRoutes.token(), { code })
}

const check = () => {
  return apiAxiosInstance.get(githubRoutes.check())
}

export const githubApi = {
  link,
  token,
  check
}
